import { HeroTrophy, NftItemRarity, NftSkinItemRarity, NtfHeroClassType } from 'src/utils/types';
import * as Constants from './constants';
import { SearchParams } from 'src/models';
import floor from 'lodash/floor';
import ceil from 'lodash/ceil';
import isFinite from 'lodash/isFinite';
export const trophyMap = {
  [HeroTrophy.H]: 1,
  [HeroTrophy.G]: 2,
  [HeroTrophy.F]: 3,
  [HeroTrophy.E]: 4,
  [HeroTrophy.D]: 5,
  [HeroTrophy.C]: 6,
  [HeroTrophy.B]: 7,
  [HeroTrophy.A]: 8,
  [HeroTrophy.S]: 9,
  [HeroTrophy.SS]: 10
};
export const battleMap = {
  '0': {
    value: 0,
    option: 1
  },
  '200': {
    value: 200,
    option: 2
  },
  '400': {
    value: 400,
    option: 3
  },
  '600': {
    value: 600,
    option: 4
  },
  '800': {
    value: 800,
    option: 5
  },
  '1000': {
    value: 1000,
    option: 6
  },
  infin: {
    value: Number.MAX_SAFE_INTEGER,
    option: 7
  }
};
export const batPercentMap = {
  '0': {
    value: 0,
    option: 1
  },
  '20': {
    value: 20,
    option: 2
  },
  '40': {
    value: 40,
    option: 3
  },
  '60': {
    value: 60,
    option: 4
  },
  '80': {
    value: 80,
    option: 5
  },
  '100': {
    value: 100,
    option: 6
  }
};
export const filterCategories = [{
  id: 'item_class',
  label: 'Class',
  options: ['tank', 'marksman', 'assassin']
}];
export const filterOptions = [{
  id: 'legendary',
  label: 'Legendary',
  isSelect: searchParams => {
    var _searchParams$heroRar;

    return !!((_searchParams$heroRar = searchParams.heroRarity) !== null && _searchParams$heroRar !== void 0 && _searchParams$heroRar.split(',').includes(NftItemRarity.LEGENDARY.toString()));
  },
  setSelect: (searchParams, selected) => {
    var _searchParams$heroRar2;

    const heroRarity = new Set((_searchParams$heroRar2 = searchParams.heroRarity) === null || _searchParams$heroRar2 === void 0 ? void 0 : _searchParams$heroRar2.split(','));

    if (selected) {
      heroRarity.add(NftItemRarity.LEGENDARY.toString());
    } else {
      heroRarity.delete(NftItemRarity.LEGENDARY.toString());
    }

    return { ...searchParams,
      heroRarity: heroRarity.size ? [...heroRarity.values()].join() : undefined
    };
  }
}, {
  id: 'epic',
  label: 'Epic',
  isSelect: searchParams => {
    var _searchParams$heroRar3;

    return !!((_searchParams$heroRar3 = searchParams.heroRarity) !== null && _searchParams$heroRar3 !== void 0 && _searchParams$heroRar3.split(',').includes(NftItemRarity.EPIC.toString()));
  },
  setSelect: (searchParams, selected) => {
    var _searchParams$heroRar4;

    const heroRarity = new Set((_searchParams$heroRar4 = searchParams.heroRarity) === null || _searchParams$heroRar4 === void 0 ? void 0 : _searchParams$heroRar4.split(','));

    if (selected) {
      heroRarity.add(NftItemRarity.EPIC.toString());
    } else {
      heroRarity.delete(NftItemRarity.EPIC.toString());
    }

    return { ...searchParams,
      heroRarity: heroRarity.size ? [...heroRarity.values()].join() : undefined
    };
  }
}, {
  id: 'common',
  label: 'Common',
  isSelect: searchParams => {
    var _searchParams$heroRar5;

    return !!((_searchParams$heroRar5 = searchParams.heroRarity) !== null && _searchParams$heroRar5 !== void 0 && _searchParams$heroRar5.split(',').includes(NftItemRarity.COMMON.toString()));
  },
  setSelect: (searchParams, selected) => {
    var _searchParams$heroRar6;

    const heroRarity = new Set((_searchParams$heroRar6 = searchParams.heroRarity) === null || _searchParams$heroRar6 === void 0 ? void 0 : _searchParams$heroRar6.split(','));

    if (selected) {
      heroRarity.add(NftItemRarity.COMMON.toString());
    } else {
      heroRarity.delete(NftItemRarity.COMMON.toString());
    }

    return { ...searchParams,
      heroRarity: heroRarity.size ? [...heroRarity.values()].join() : undefined
    };
  }
}, {
  id: 'normal',
  label: 'Normal',
  isSelect: searchParams => {
    var _searchParams$skinRar;

    return !!((_searchParams$skinRar = searchParams.skinRarity) !== null && _searchParams$skinRar !== void 0 && _searchParams$skinRar.split(',').includes(NftSkinItemRarity.NORMAL.toString()));
  },
  setSelect: (searchParams, selected) => {
    var _searchParams$skinRar2;

    const skinRarity = new Set((_searchParams$skinRar2 = searchParams.skinRarity) === null || _searchParams$skinRar2 === void 0 ? void 0 : _searchParams$skinRar2.split(','));

    if (selected) {
      skinRarity.add(NftSkinItemRarity.NORMAL.toString());
    } else {
      skinRarity.delete(NftSkinItemRarity.NORMAL.toString());
    }

    return { ...searchParams,
      skinRarity: skinRarity.size ? [...skinRarity.values()].join() : undefined
    };
  }
}, {
  id: 'rare',
  label: 'Rare',
  isSelect: searchParams => {
    var _searchParams$skinRar3;

    return !!((_searchParams$skinRar3 = searchParams.skinRarity) !== null && _searchParams$skinRar3 !== void 0 && _searchParams$skinRar3.split(',').includes(NftSkinItemRarity.RARE.toString()));
  },
  setSelect: (searchParams, selected) => {
    var _searchParams$skinRar4;

    const skinRarity = new Set((_searchParams$skinRar4 = searchParams.skinRarity) === null || _searchParams$skinRar4 === void 0 ? void 0 : _searchParams$skinRar4.split(','));

    if (selected) {
      skinRarity.add(NftSkinItemRarity.RARE.toString());
    } else {
      skinRarity.delete(NftSkinItemRarity.RARE.toString());
    }

    return { ...searchParams,
      skinRarity: skinRarity.size ? [...skinRarity.values()].join() : undefined
    };
  }
}, {
  id: 'mythical',
  label: 'Mythical',
  isSelect: searchParams => {
    var _searchParams$skinRar5;

    return !!((_searchParams$skinRar5 = searchParams.skinRarity) !== null && _searchParams$skinRar5 !== void 0 && _searchParams$skinRar5.split(',').includes(NftSkinItemRarity.MYTHICAL.toString()));
  },
  setSelect: (searchParams, selected) => {
    var _searchParams$skinRar6;

    const skinRarity = new Set((_searchParams$skinRar6 = searchParams.skinRarity) === null || _searchParams$skinRar6 === void 0 ? void 0 : _searchParams$skinRar6.split(','));

    if (selected) {
      skinRarity.add(NftSkinItemRarity.MYTHICAL.toString());
    } else {
      skinRarity.delete(NftSkinItemRarity.MYTHICAL.toString());
    }

    return { ...searchParams,
      skinRarity: skinRarity.size ? [...skinRarity.values()].join() : undefined
    };
  }
}, {
  id: 'tank',
  label: 'Tank',
  isSelect: searchParams => {
    var _searchParams$heroRol;

    return !!((_searchParams$heroRol = searchParams.heroRole) !== null && _searchParams$heroRol !== void 0 && _searchParams$heroRol.split(',').includes(NtfHeroClassType.TANK.toString()));
  },
  setSelect: (searchParams, selected) => {
    var _searchParams$heroRol2;

    const heroClass = new Set((_searchParams$heroRol2 = searchParams.heroRole) === null || _searchParams$heroRol2 === void 0 ? void 0 : _searchParams$heroRol2.split(','));

    if (selected) {
      heroClass.add(NtfHeroClassType.TANK.toString());
    } else {
      heroClass.delete(NtfHeroClassType.TANK.toString());
    }

    return { ...searchParams,
      heroRole: heroClass.size ? [...heroClass.values()].join() : undefined
    };
  }
}, {
  id: 'marksman',
  label: 'Marksman',
  isSelect: searchParams => {
    var _searchParams$heroRol3;

    return !!((_searchParams$heroRol3 = searchParams.heroRole) !== null && _searchParams$heroRol3 !== void 0 && _searchParams$heroRol3.split(',').includes(NtfHeroClassType.MARKSMAN.toString()));
  },
  setSelect: (searchParams, selected) => {
    var _searchParams$heroRol4;

    const heroClass = new Set((_searchParams$heroRol4 = searchParams.heroRole) === null || _searchParams$heroRol4 === void 0 ? void 0 : _searchParams$heroRol4.split(','));

    if (selected) {
      heroClass.add(NtfHeroClassType.MARKSMAN.toString());
    } else {
      heroClass.delete(NtfHeroClassType.MARKSMAN.toString());
    }

    return { ...searchParams,
      heroRole: heroClass.size ? [...heroClass.values()].join() : undefined
    };
  }
}, {
  id: 'assassin',
  label: 'Assassin',
  isSelect: searchParams => {
    var _searchParams$heroRol5;

    return !!((_searchParams$heroRol5 = searchParams.heroRole) !== null && _searchParams$heroRol5 !== void 0 && _searchParams$heroRol5.split(',').includes(NtfHeroClassType.ASSASSIN.toString()));
  },
  setSelect: (searchParams, selected) => {
    var _searchParams$heroRol6;

    const heroClass = new Set((_searchParams$heroRol6 = searchParams.heroRole) === null || _searchParams$heroRol6 === void 0 ? void 0 : _searchParams$heroRol6.split(','));

    if (selected) {
      heroClass.add(NtfHeroClassType.ASSASSIN.toString());
    } else {
      heroClass.delete(NtfHeroClassType.ASSASSIN.toString());
    }

    return { ...searchParams,
      heroRole: heroClass.size ? [...heroClass.values()].join() : undefined
    };
  }
}];
export const filterGroupCategories = {
  level: {
    id: 'level',
    label: 'Level',
    option: {
      min: Constants.MIN_LEVEL,
      max: Constants.MAX_LEVEL
    }
  },
  trophy: {
    id: 'trophy_class',
    label: 'Trophy class',
    option: {
      min: trophyMap[HeroTrophy.H],
      max: trophyMap[HeroTrophy.SS]
    },
    marks: [{
      label: 'H',
      value: trophyMap[HeroTrophy.H]
    }, {
      label: 'G',
      value: trophyMap[HeroTrophy.G]
    }, {
      label: 'F',
      value: trophyMap[HeroTrophy.F]
    }, {
      label: 'E',
      value: trophyMap[HeroTrophy.E]
    }, {
      label: 'D',
      value: trophyMap[HeroTrophy.D]
    }, {
      label: 'C',
      value: trophyMap[HeroTrophy.C]
    }, {
      label: 'B',
      value: trophyMap[HeroTrophy.B]
    }, {
      label: 'A',
      value: trophyMap[HeroTrophy.A]
    }, {
      label: 'S',
      value: trophyMap[HeroTrophy.S]
    }, {
      label: 'SS',
      value: trophyMap[HeroTrophy.SS]
    }]
  },
  batPercent: {
    id: 'batPercent',
    label: 'Remaining THC Battles %',
    option: {
      min: batPercentMap['0'].option,
      max: batPercentMap['100'].option
    },
    marks: [{
      label: '0',
      value: batPercentMap['0'].option
    }, {
      label: '20',
      value: batPercentMap['20'].option
    }, {
      label: '40',
      value: batPercentMap['40'].option
    }, {
      label: '60',
      value: batPercentMap['60'].option
    }, {
      label: '80',
      value: batPercentMap['80'].option
    }, {
      label: '100',
      value: batPercentMap['100'].option
    }]
  },
  battle: {
    id: 'battle',
    label: 'Battle',
    option: {
      min: battleMap['0'].option,
      max: battleMap['infin'].option
    },
    marks: [{
      label: '0',
      value: battleMap['0'].option
    }, {
      label: '200',
      value: battleMap['200'].option
    }, {
      label: '400',
      value: battleMap['400'].option
    }, {
      label: '600',
      value: battleMap['600'].option
    }, {
      label: '800',
      value: battleMap['800'].option
    }, {
      label: '1000',
      value: battleMap['1000'].option
    }, {
      label: '∞',
      value: battleMap['infin'].option
    }]
  },
  price: {
    id: 'price',
    label: 'PRICE RANGE (THC)'
  }
};
export const rangeFilterCategories = [filterGroupCategories.batPercent, filterGroupCategories.battle, filterGroupCategories.level, filterGroupCategories.trophy];
export const inputRangeFilterCategories = [filterGroupCategories.price];
export const filterGroupOptions = {
  level: {
    id: 'level',
    getCurrentValue: searchParams => ({
      min: searchParams.levelMin || Constants.MIN_LEVEL,
      max: searchParams.levelMax || Constants.MAX_LEVEL
    }),
    setRange: (searchParams, value, changed) => ({ ...searchParams,
      levelMin: changed ? value.min : undefined,
      levelMax: changed ? value.max : undefined
    })
  },
  batPercent: {
    id: 'batPercent',
    getCurrentValue: searchParams => {
      var _Object$values$find, _Object$values$find2;

      return {
        min: ((_Object$values$find = Object.values(batPercentMap).find(val => val.value === searchParams.batPercentMin)) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.option) || batPercentMap['0'].option,
        max: ((_Object$values$find2 = Object.values(batPercentMap).find(val => val.value === searchParams.batPercentMax)) === null || _Object$values$find2 === void 0 ? void 0 : _Object$values$find2.option) || batPercentMap['100'].option
      };
    },
    setRange: (searchParams, value, changed) => {
      var _Object$values$find3, _Object$values$find4;

      return { ...searchParams,
        batPercentMax: changed ? (_Object$values$find3 = Object.values(batPercentMap).find(val => val.option === value.max)) === null || _Object$values$find3 === void 0 ? void 0 : _Object$values$find3.value : undefined,
        batPercentMin: (_Object$values$find4 = Object.values(batPercentMap).find(val => val.option === value.min)) === null || _Object$values$find4 === void 0 ? void 0 : _Object$values$find4.value
      };
    }
  },
  battle: {
    id: 'battle',
    getCurrentValue: searchParams => {
      var _Object$values$find5, _Object$values$find6;

      return {
        min: ((_Object$values$find5 = Object.values(battleMap).find(val => val.value === searchParams.battleMin)) === null || _Object$values$find5 === void 0 ? void 0 : _Object$values$find5.option) || battleMap['0'].option,
        max: ((_Object$values$find6 = Object.values(battleMap).find(val => val.value === searchParams.battleMax)) === null || _Object$values$find6 === void 0 ? void 0 : _Object$values$find6.option) || battleMap['infin'].option
      };
    },
    setRange: (searchParams, value, changed) => {
      var _Object$values$find7, _Object$values$find8;

      return { ...searchParams,
        battleMax: changed ? (_Object$values$find7 = Object.values(battleMap).find(val => val.option === value.max)) === null || _Object$values$find7 === void 0 ? void 0 : _Object$values$find7.value : undefined,
        battleMin: changed ? (_Object$values$find8 = Object.values(battleMap).find(val => val.option === value.min)) === null || _Object$values$find8 === void 0 ? void 0 : _Object$values$find8.value : undefined
      };
    }
  },
  trophy: {
    id: 'trophy_class',
    getCurrentValue: searchParams => ({
      min: searchParams.trophyMin || trophyMap[HeroTrophy.H],
      max: searchParams.trophyMax || trophyMap[HeroTrophy.SS]
    }),
    setRange: (searchParams, value, changed) => ({ ...searchParams,
      trophyMax: changed ? value.max : undefined,
      trophyMin: changed ? value.min : undefined
    })
  },
  price: {
    id: 'price',
    getCurrentValue: searchParams => ({
      min: searchParams.priceMin !== undefined ? floor(searchParams.priceMin / Constants.ACTUAL_PRICE, 8) : undefined,
      max: searchParams.priceMax !== undefined ? floor(searchParams.priceMax / Constants.ACTUAL_PRICE, 8) : undefined,
      validate: text => {
        if (!text || !isFinite(Number(text))) {
          return undefined;
        }

        return Number(text);
      }
    }),
    setRange: (searchParams, value, changed) => ({ ...searchParams,
      priceMin: changed && value.min !== undefined ? floor(value.min * Constants.ACTUAL_PRICE) : undefined,
      priceMax: changed && value.max !== undefined ? ceil(value.max * Constants.ACTUAL_PRICE) : undefined
    })
  }
};
export const rangeFilterOptions = [filterGroupOptions.batPercent, filterGroupOptions.battle, filterGroupOptions.level, filterGroupOptions.trophy];
export const inputRangeFilterOptions = [filterGroupOptions.price];
export const selectFilterCategories = [{
  id: 'hero',
  label: 'Hero',
  rarity: {
    id: 'item_rarity',
    label: 'Rarity',
    options: ['common', 'epic', 'legendary']
  }
}, {
  id: 'skin',
  label: 'Skin',
  rarity: {
    id: 'item_skin_rarity',
    label: 'Skin Rarity',
    options: ['normal', 'rare', 'mythical']
  }
}];
export const selectFilterOptions = [{
  id: 'hero',
  label: 'Hero',
  selectedList: searchParams => searchParams.heroTypeIds ? searchParams.heroTypeIds.split(',') : undefined,
  setSelect: (searchParams, data) => ({ ...searchParams,
    heroTypeIds: data ? data.join(',') : undefined
  }),
  enabledList: () => undefined,
  updateList: searchParams => searchParams
}, {
  id: 'skin',
  label: 'Skin',
  selectedList: searchParams => searchParams.skinIds ? searchParams.skinIds.split(',') : undefined,
  setSelect: (searchParams, data) => ({ ...searchParams,
    skinIds: data ? data.join(',') : undefined
  }),
  enabledList: searchParams => searchParams.heroTypeIds ? searchParams.heroTypeIds.split(',') : undefined,
  updateList: (searchParams, heroData, skinData) => ({ ...searchParams,
    heroTypeIds: heroData ? heroData.join(',') : undefined,
    skinIds: skinData ? skinData.join(',') : undefined
  })
}];
export const filterPanelConfig = {
  categories: filterCategories,
  options: filterOptions,
  rangeCategories: rangeFilterCategories,
  rangeOptions: rangeFilterOptions,
  selectCategories: selectFilterCategories,
  selectOptions: selectFilterOptions,
  inputRangeCategories: inputRangeFilterCategories,
  inputRangeOptions: inputRangeFilterOptions
};